import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {},
    fallbackLng: "en",
    supportedLngs: ["en", "pt-BR"],
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "i18nextLng",
      caches: ["localStorage"],
    },
    interpolation: {
      escapeValue: false,
    },
  });

async function loadTranslations() {
  const [en, ptBR] = await Promise.all([
    import("./en/translation.json"),
    import("./pt-BR/translation.json"),
  ]);
  i18n.addResourceBundle("en", "translation", en.default, true, true);
  i18n.addResourceBundle("pt-BR", "translation", ptBR.default, true, true);
}

loadTranslations();

export default i18n;
